<mat-card class="communication-tile" (click)="onClick()">
  <mat-card-header>
    <mat-card-title>{{ communication.title }}</mat-card-title>
    <mat-card-subtitle>{{ communication.createdAt | date }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <p>{{ truncatedBody }}</p>
  </mat-card-content>
</mat-card>
